export const modalStyles = {
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: '999999',
    overflow: 'auto'
  },
  content: {
    position: 'absolute',
    top: '40px',
    bottom: 'auto',
    left: '40px',
    right: '40px',
    background: 'rgb(255, 255, 255)',
    overflow: 'auto',
    outline: 'none',
    padding: 0,
    border: 'none',
    maxWidth: '80rem',
    margin: '0 auto',
  }
};




// WEBPACK FOOTER //
// ./src/containers/common/ModalStyles.js